import React from 'react';
import { Helmet } from 'react-helmet-async';

import { dark } from '../stylesheets/colors.css';

export default () => (
  <Helmet>
    <meta name="theme-color" content={dark} />
    <meta name="msapplication-navbutton-color" content={dark} />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-status-bar-style" content={dark} />
  </Helmet>
);
